module.exports = __webpack_public_path__ + "img/イノフェス_talksession_nft_企画書_ページ_1.693c2257.png";